import uiLoaderMessage from './loader-message/index.vue'

export {
    uiLoaderMessage,
}